// Central content + asset data for the Air Fryer Argentina MegaPack landing page.

export const IMAGES = {
  mockupPrincipal:
    'https://cdn.magicpatterns.com/uploads/qi7byQMBaJKi3wMnNjbXwD/Mockup_principal.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/tQ5MxXtQybpWbPUQKGUfCm/bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/1vjGy9zN1eRAwDEgAE1nQ2/bono_2_.2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/qGur7U9HbjEJSerefi4A68/bono_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/suaayU6Y8BYTvHJaMh8vtm/bono_4.png',
  bono5:
    'https://cdn.magicpatterns.com/patterns/generated-images/2fed9c33-f32d-4205-af29-36fe026245ea.jpg',
  heroFood:
    'https://cdn.magicpatterns.com/patterns/generated-images/a4a5282f-0d19-4cc4-9cee-2ee3b898cd9e.jpg',
  milanesa:
    'https://cdn.magicpatterns.com/patterns/generated-images/7047c197-ae6b-474a-ae7e-acdb199def02.jpg',
  avatarsGridA:
    'https://cdn.magicpatterns.com/patterns/generated-images/283dfb0c-4062-4c56-bace-b171c61dd273.jpg',
  avatarsGridB:
    'https://cdn.magicpatterns.com/patterns/generated-images/1b5ca953-1744-4a32-9c50-167e0596f0dc.jpg',
} as const

export interface Tomo {
  numero: string
  titulo: string
  descripcion: string
  color: string
  rango: string
  enfoque: string
  destacados: string[]
  masRecetas: string
}

export const TOMOS: Tomo[] = [
  {
    numero: 'TOMO 1',
    titulo: 'Carnes y Fundamentos',
    descripcion: 'Del pollo al spiedo barrial al bife de chorizo perfecto.',
    color: '#f59e0b',
    rango: 'Recetas 1 a 60',
    enfoque: 'Calibración de la máquina, condimentos esenciales y el sistema para dominar proteínas.',
    destacados: [
      'Pollo al Spiedo “Barrial”',
      'Milanesa de Nalga “Bodegón”',
      'Bife de Chorizo Sellado',
      'Entraña Express',
      'Choripán en 10 minutos',
    ],
    masRecetas: '+55 recetas favoritas de los argentinos: alitas, albóndigas, vacío, bondiola y más.',
  },
  {
    numero: 'TOMO 2',
    titulo: 'Vegetales y Mar',
    descripcion: 'Guarniciones adictivas y pescados sin olor en casa.',
    color: '#38bdf8',
    rango: 'Recetas 61 a 120',
    enfoque: 'Vegetales crocantes, guarniciones económicas y pescados perfectos sin ensuciar la cocina.',
    destacados: [
      'Papas Fritas “Anti-Fracaso”',
      'Zapallitos Rellenos Livianos',
      'Milanesitas de Berenjena',
      'Filet de Merluza con Costra',
      'Salmón con Miel y Soja',
    ],
    masRecetas: '+55 recetas favoritas: batatas, buñuelos, empanadas de atún, rabas y más.',
  },
  {
    numero: 'TOMO 3',
    titulo: 'Masas y Meriendas',
    descripcion: 'Empanadas, tartas y facturas como recién salidas del horno.',
    color: '#fbbf24',
    rango: 'Recetas 121 a 180',
    enfoque: 'Masas crocantes, desayunos y clásicos para el mate que reemplazan delivery y panadería.',
    destacados: [
      'Empanadas de Carne sin Fritura',
      'Tarta de Jamón y Queso “Piso Seco”',
      'Pizzetas Individuales de 4 minutos',
      'Tortas Fritas “Sin Culpa”',
      'Medialunas con Jamón y Queso',
    ],
    masRecetas: '+55 recetas favoritas: chipá, pepas, tostados, facturas y mucho más para el mate.',
  },
  {
    numero: 'TOMO 4',
    titulo: 'Postres y Picadas',
    descripcion: 'Convertite en el anfitrión estrella con postres gourmet y snacks de bar.',
    color: '#a78bfa',
    rango: 'Recetas 181 a 250',
    enfoque: 'Dulces, picadas, recalentado pro, platos fit y hacks para aprovechar cada comida.',
    destacados: [
      'Volcán de Chocolate',
      'Banana Asada con Dulce de Leche',
      'Bastoncitos de Muzzarella',
      'Empanaditas de Copetín',
      'La Pizza de Ayer, Mejor que Hoy',
    ],
    masRecetas: '+65 recetas favoritas: churros, brownies, tequeños, provoleta y hacks de experto.',
  },
]

export interface Bono {
  numero: string
  titulo: string
  descripcion: string
  valor: string
  imagen: string
}

export const BONOS: Bono[] = [
  {
    numero: 'Bonus 1',
    titulo: 'Tabla de Tiempos y Temp.',
    descripcion: 'Imprimible para pegar en la heladera. Nunca más adivines cuánto va cada cosa.',
    valor: '$14.900',
    imagen: IMAGES.bono1,
  },
  {
    numero: 'Bonus 2',
    titulo: 'Menú "Mes Resuelto"',
    descripcion: 'Calendario de 30 días con qué cocinar cada noche. Cero estrés.',
    valor: '$17.900',
    imagen: IMAGES.bono2,
  },
  {
    numero: 'Bonus 3',
    titulo: 'Carnes Baratas que saben a Lomo',
    descripcion: 'El hack de ahorro para que cortes económicos queden de restaurante.',
    valor: '$15.900',
    imagen: IMAGES.bono3,
  },
  {
    numero: 'Bonus 4',
    titulo: '50 Recetas Fit e Hiper-Proteicas',
    descripcion: 'Comé rico y saludable sin resignar sabor ni sumar aceite.',
    valor: '$18.900',
    imagen: IMAGES.bono4,
  },
  {
    numero: 'Bonus 5',
    titulo: 'Guía de Limpieza y Mantenimiento',
    descripcion: 'Cuidá tu unidad para que te dure años como el primer día.',
    valor: '$13.900',
    imagen: IMAGES.bono5,
  },
]

export interface Faq {
  pregunta: string
  respuesta: string
}

export const FAQS: Faq[] = [
  {
    pregunta: '¿Sirve para cualquier marca de freidora?',
    respuesta:
      'Sí. Peabody, Philips, Atma, Liliana, Gadnic... todas funcionan con el mismo principio de aire caliente. Las recetas están pensadas para que las adaptes a tu modelo en segundos.',
  },
  {
    pregunta: '¿Son ingredientes caros o difíciles de conseguir?',
    respuesta:
      'Para nada. Usamos lo que hay en cualquier súper o verdulería de Argentina: nalga, pollo, zapallitos, harina, papa. Sin cosas raras ni importadas.',
  },
  {
    pregunta: '¿Es un libro físico que me llega a casa?',
    respuesta:
      'Es un pack 100% digital de acceso inmediato. Lo abrís en el celular, la tablet o la compu y cocinás mirando la pantalla. No esperás correo ni pagás envío.',
  },
  {
    pregunta: '¿Cómo lo recibo después de pagar?',
    respuesta:
      'Apenas se aprueba el pago te llega el acceso al mail al instante. En menos de 2 minutos ya estás cocinando tu primera receta.',
  },
  {
    pregunta: '¿Y si no me gusta o no es para mí?',
    respuesta:
      'Tenés 7 días de garantía total. Si no te convence, te devolvemos el 100% sin preguntas y te quedás igual con el material. El riesgo es todo nuestro.',
  },
]

export interface Testimonio {
  nombre: string
  ciudad: string
  texto: string
  avatarGrid: 'A' | 'B'
  pos: number // índice 0-8 dentro de la grilla 3x3
}

export const TESTIMONIOS: Testimonio[] = [
  {
    nombre: 'Carla Giménez',
    ciudad: 'Rosario, Santa Fe',
    texto:
      'No lo podía creer. La primera milanesa me salió crocante de verdad, sin una gota de aceite. Mis hijos me pidieron que haga de nuevo el mismo día. Vale cada peso.',
    avatarGrid: 'A',
    pos: 0,
  },
  {
    nombre: 'Diego Ferreyra',
    ciudad: 'Córdoba Capital',
    texto:
      'Compré la freidora hace un año y la usaba solo para papas. Con el MegaPack la uso todos los días. El pollo al spiedo casero es una locura, igual al del barrio pero mucho más barato.',
    avatarGrid: 'A',
    pos: 1,
  },
  {
    nombre: 'Susana Roldán',
    ciudad: 'La Plata, Buenos Aires',
    texto:
      'Lo mejor es que dejamos de pedir delivery. Antes gastábamos una fortuna los findes. Ahora hago las empanadas y las picadas yo. Se paga solo en una semana.',
    avatarGrid: 'A',
    pos: 2,
  },
  {
    nombre: 'Marcelo Quiroga',
    ciudad: 'Mendoza',
    texto:
      'El bonus de las carnes baratas es oro puro. Compro cortes económicos y quedan tiernos como un lomo. Mi señora no lo podía creer.',
    avatarGrid: 'A',
    pos: 3,
  },
  {
    nombre: 'Patricia Sosa',
    ciudad: 'Mar del Plata',
    texto:
      'Tengo 58 años y pensé que no lo iba a entender. Es facilísimo, las recetas están re claras y las hago desde el celu mientras cocino. Recomendadísimo.',
    avatarGrid: 'A',
    pos: 4,
  },
  {
    nombre: 'Fernando Aguirre',
    ciudad: 'San Miguel de Tucumán',
    texto:
      'La tabla de tiempos y temperaturas la imprimí y la pegué en la heladera. Cambió todo. Ya no quemo ni dejo crudo nada. Simple y práctico.',
    avatarGrid: 'A',
    pos: 5,
  },
  {
    nombre: 'Verónica Ledesma',
    ciudad: 'Neuquén',
    texto:
      'Con el menú del mes resuelto no pienso más qué cocinar. Ya sé qué toca cada noche y hago la compra una vez. Me sacó un peso de encima enorme.',
    avatarGrid: 'B',
    pos: 0,
  },
  {
    nombre: 'Roberto Medina',
    ciudad: 'Salta',
    texto:
      'Las recetas fit me ayudaron a bajar 4 kilos comiendo rico. Nunca creí que la freidora podía ser tan saludable. Excelente inversión.',
    avatarGrid: 'B',
    pos: 1,
  },
  {
    nombre: 'Analía Bustos',
    ciudad: 'Bahía Blanca',
    texto:
      'Los postres son un golazo. Hice el volcán de chocolate para el cumple de mi nena y quedaron todos fascinados. Parezco chef y no me di cuenta.',
    avatarGrid: 'B',
    pos: 2,
  },
  {
    nombre: 'Gustavo Peralta',
    ciudad: 'Resistencia, Chaco',
    texto:
      'Pago único y acceso al toque. En 5 minutos ya estaba cocinando. Nada de esperar. Muy honesto todo, tal cual lo prometen.',
    avatarGrid: 'B',
    pos: 3,
  },
  {
    nombre: 'Mónica Vera',
    ciudad: 'Santiago del Estero',
    texto:
      'Somos familia numerosa y ahorrar en el súper era imposible. Con estas recetas rindo mucho más la comida. Los chicos comen de todo ahora.',
    avatarGrid: 'B',
    pos: 4,
  },
  {
    nombre: 'Javier Ríos',
    ciudad: 'San Juan',
    texto:
      'Lo compré medio desconfiado por lo barato. Es muchísimo más de lo que esperaba. 250 recetas de verdad, no relleno. Un fenómeno.',
    avatarGrid: 'B',
    pos: 5,
  },
  {
    nombre: 'Silvina Cabrera',
    ciudad: 'Paraná, Entre Ríos',
    texto:
      'Llego cansada del laburo y en 15 minutos tengo la cena lista sin ensuciar media cocina. Es exactamente lo que necesitaba. Gracias de verdad.',
    avatarGrid: 'A',
    pos: 6,
  },
]

export interface PopClient {
  nombre: string
  ciudad: string
  tiempo: string
}

export const POP_CLIENTS: PopClient[] = [
  { nombre: 'Laura M.', ciudad: 'Córdoba', tiempo: 'hace 2 minutos' },
  { nombre: 'Martín G.', ciudad: 'Rosario, Santa Fe', tiempo: 'hace 4 minutos' },
  { nombre: 'Claudia R.', ciudad: 'La Plata, Bs. As.', tiempo: 'hace 6 minutos' },
  { nombre: 'Sergio P.', ciudad: 'Mendoza', tiempo: 'hace 8 minutos' },
  { nombre: 'Natalia F.', ciudad: 'Mar del Plata', tiempo: 'hace 11 minutos' },
  { nombre: 'Hernán V.', ciudad: 'Tucumán', tiempo: 'hace 13 minutos' },
  { nombre: 'Gabriela S.', ciudad: 'Neuquén', tiempo: 'hace 15 minutos' },
  { nombre: 'Andrés L.', ciudad: 'Salta', tiempo: 'hace 17 minutos' },
  { nombre: 'Romina T.', ciudad: 'Bahía Blanca', tiempo: 'hace 19 minutos' },
  { nombre: 'Pablo C.', ciudad: 'San Juan', tiempo: 'hace 22 minutos' },
  { nombre: 'Valeria D.', ciudad: 'Paraná, E. Ríos', tiempo: 'hace 24 minutos' },
  { nombre: 'Lucas B.', ciudad: 'Resistencia, Chaco', tiempo: 'hace 27 minutos' },
]

// Devuelve el object-position para recortar un rostro de una grilla 3x2.
export function avatarStyle(grid: 'A' | 'B', pos: number): {
  backgroundImage: string
  backgroundSize: string
  backgroundPosition: string
} {
  const url = grid === 'A' ? IMAGES.avatarsGridA : IMAGES.avatarsGridB
  const col = pos % 3 // 0,1,2
  const row = Math.floor(pos / 3) // 0,1
  // 3 columnas y 3 filas -> 0%, 50%, 100%
  const x = col === 0 ? 0 : col === 1 ? 50 : 100
  const y = row === 0 ? 0 : row === 1 ? 50 : 100
  return {
    backgroundImage: `url(${url})`,
    backgroundSize: '300% 300%',
    backgroundPosition: `${x}% ${y}%`,
  }
}
